export default "/static/assets/arrow_right.64bd35c3d0048f8385a811ee6f268a9b.svg";